
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Définition et Importance du Plomb en Matière d'Environnement et de Santé",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez ce qu'est le 'Définition lead', son importance et comment il est utilisé dans différents contextes. Renseignez-vous pour mieux comprendre ce terme.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Définition et Importance du Plomb en Matière d'Environnement et de Santé",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez ce qu'est le 'Définition lead', son importance et comment il est utilisé dans différents contextes. Renseignez-vous pour mieux comprendre ce terme.",
        },
      ],
    };
  },
};
